import { FC } from 'react';
import { useLocation } from 'react-router';

import { styled } from '@portal/common/theme';

import { FAVORITE_CONTENT_PATH } from '../../../router/paths';
import MyListsMenu from './MyListsMenu';
import PublicListsMenu from './PublicListsMenu';

const SidenavSubmenu = styled('div')(({ theme }) => ({
    color: theme.color.white,
    background: theme.color.gray95,
    display: 'flex',
    flexFlow: 'column nowrap',
    padding: '60px 20px 0 20px',
    overflowY: 'hidden',
    ':hover': {
        overflowY: 'scroll',
    },

    minWidth: 160,
    width: 160,
    [theme.breakpoint.md]: {
        padding: '90px 30px 0 30px',
        minWidth: 230,
        width: 230,
    },
}));

const ListsRoute: FC = () => {
    const location = useLocation();

    // Only render the submenu if we're on a favorite-content path
    if (!location.pathname.startsWith(FAVORITE_CONTENT_PATH)) {
        return null;
    }

    return (
        <SidenavSubmenu>
            <MyListsMenu />
            <PublicListsMenu />
        </SidenavSubmenu>
    );
};

export default ListsRoute;
